class NgOrderDetails extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.sync(this.dataset.variantId);
    this.closest('.shopify-section, dialog, product-card')?.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-picker');
      if (!picker || picker.dataset.productId !== this.dataset.productId) return;
      const selected = picker.querySelector('input[type="radio"]:checked');
      const variant = this.variants.find(item => (item.public_title || item.title) === selected?.value);
      if (variant) this.sync(variant.id);
    }, { signal: this.controller.signal });
    this.addEventListener('change', () => this.checkUnique(), { signal: this.controller.signal });
    this.checkUnique();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  checkUnique() {
    const selects = [...this.querySelectorAll('[data-ng-produce] select')].filter(input => !input.disabled);
    const values = selects.map(input => input.value).filter(Boolean);
    for (const input of selects) {
      const duplicate = input.value && values.filter(value => value === input.value).length > 1;
      input.setCustomValidity(duplicate ? this.dataset.duplicateError : '');
      for (const option of input.options) option.disabled = Boolean(option.value && option.value !== input.value && values.includes(option.value));
    }
  }

  sync(id) {
    const variant = this.variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    const title = variant.public_title || variant.title;
    const count = title === 'Set of 10' ? 10 : title === 'Set of 5' ? 5 : 0;
    this.querySelectorAll('[data-ng-group]').forEach(group => {
      const type = group.dataset.ngGroup;
      const active = type === 'garden' ? title.includes('Custom Color') : type === 'fruit' ? title.includes('Extra Fruit') : count > 0;
      group.hidden = !active;
      if (type !== 'produce') group.querySelectorAll('textarea, select').forEach(input => {
        input.disabled = !active;
        input.required = active;
      });
    });
    this.querySelectorAll('[data-ng-produce]').forEach(row => {
      const active = Number(row.dataset.ngProduce) <= count;
      row.hidden = !active;
      const input = row.querySelector('select');
      input.disabled = !active;
      input.required = active;
    });
    this.checkUnique();
  }
}

if (!customElements.get('ng-order-details')) customElements.define('ng-order-details', NgOrderDetails);
